import {Component, Input, OnDestroy, OnInit} from '@angular/core';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {MyDeviceRequestContainerModel} from '../../../models/my-device-request-container.model';
import {SupplyAcquisitionTypeEnum} from '../../../enums/supply-acquisition-type.enum';
import {RPriceInfoModel} from '../../../models/r-price-info.model';
import {EditModalCustomPriceTableService} from '../../../services/edit-modal-custom-price-table.service';
import {MyPageRPricesSelectBase} from '../../../enums/my-page-rprices-select-base.enum';
import {PriceInfoModel} from '../../../models/price-info.model';
import {RPriceInfoModalComponent} from '../r-price-info-modal/r-price-info-modal.component';
import {Subscription} from 'rxjs';
import {ModalVisibilityService} from '../../../services/modal-visibility.service';
import {MyPriceApprovalModeEnum} from '../../../enums/my-price-approval-mode.enum';
import {MyNotDeviceRequestContainerModel} from '../../../models/my-not-device-request-container.model';
import {DecimalPipe} from '@angular/common';
import {ProductModel} from '../../../models/product.model';
import {ModalDynamicV3Service} from '../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';

/*
 * SupplyOptionTable used on step6 only.
 * List of ordered supplies - used for both SmartPrint and "Kaufe" mode
 */

@Component({
    selector: 'app-supply-option-table',
    templateUrl: './supply-option-table.component.html',
    styleUrls: ['./supply-option-table.component.scss']
})
export class SupplyOptionTableComponent extends EditModalSectionBaseComponent implements OnInit, OnDestroy {

    @Input() usePriceApprovalMode = MyPriceApprovalModeEnum.DISABLED;

    public supplyAcquisitionTypeEnum = SupplyAcquisitionTypeEnum;
    private modalVisibilitySub: Subscription;
    private rPriceInfoModalDialogRef: any;

    constructor(public  editModalService: EditModalService,
                private editModalCustomPriceTableService: EditModalCustomPriceTableService,
                public modalVisibilityService: ModalVisibilityService,
                private modalDynamicV3Service: ModalDynamicV3Service) {
        super(editModalService);
    }

    ngOnInit() {
        super.ngOnInit();
    }


    // returns active requested devices with supplies for 6.step dialog
    public getActiveDeviceContainersList(): MyDeviceRequestContainerModel[] {
        if (this.isPrintSmartSupplyAcquisitionType()) {
            return this.model.requestedPreselectedPrintSmartDevicesWithSupplyContainers;
        } else {
            return this.model.requestedPreselectedGeneralDevicesWithSupplyContainers;
        }
    }

    public showTable(): boolean {
        // const activeDeviceContainersList = this.getActiveDeviceContainersList();
        // const test = this.model.requestedGeneralNoCategorisedSupplyContainers;
        return true;
        // return (this.isSupplyOrderActive() &&  activeDeviceContainersList?.length > 0 ) || ( this.model?.requestedGeneralNoCategorisedSupplyContainers?.length > 0);
    }

    public getTitle(): string {
        if (this.isPrintSmartSupplyAcquisitionType()) {
            return 'Für die Option „MPS“ ausgewählte Modelle*';
        } else {
            return 'Für die Option „Kaufen“ ausgewählte Modelle';
        }

    }

    private isSupplyOrderActive(): boolean {
        return this.editModalService.isSupplyOrderActive();
    }

    public isPrintSmartSupplyAcquisitionType(): boolean {
        return this.editModalService.isPrintSmartSupplyAcquisitionType();
    }

    public getSupplyAcquisitionMode(): SupplyAcquisitionTypeEnum {
        // SupplyAcquisitionType
        return SupplyAcquisitionTypeEnum[this.model.project.supplyAcquisitionType];
    }


    public getExtendedRPriceChoices(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedRPriceChoices(priceInfos);
    }

    public getExtendedRPriceValues(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedRPriceValues(priceInfos);
    }

    public isSelectedPriceTypeEqualOtherPrice(priceType: string): boolean {
        return this.editModalCustomPriceTableService.isSelectedPriceTypeEqualOtherPrice(priceType);
    }

    public priceNoteShouldBeVisible(priceType: string): boolean {
        return this.editModalCustomPriceTableService.priceNoteShouldBeVisible(priceType);
    }


    // =======
    forceFormValidationVisibility: boolean;   // logic implementation lost, is not used since 30.1.2024, or even before


    public getExtendedPagePriceChoices(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedPagePriceChoices(priceInfos);

    }

    public getExtendedPagePriceValues(priceInfos: RPriceInfoModel[]): string[] {
        return this.editModalCustomPriceTableService.getExtendedPagePriceValues(priceInfos);
    }

    public isSelectedPagePriceTypeEqualCustomPrice(selectedPrice: string): boolean {
        return MyPageRPricesSelectBase[selectedPrice] === MyPageRPricesSelectBase.CUSTOM;
    }

    public pagePriceNoteShouldBeVisible(devicePagePrices: { mono: PriceInfoModel; color: PriceInfoModel }) {
        return MyPageRPricesSelectBase[devicePagePrices.mono.selectedPrice] === MyPageRPricesSelectBase.CUSTOM ||
            MyPageRPricesSelectBase[devicePagePrices.color.selectedPrice] === MyPageRPricesSelectBase.CUSTOM;
    }

    public isActivePriceApprovalMode() {
        return this.usePriceApprovalMode === MyPriceApprovalModeEnum.ACTIVE;
    }

    public openRPricesInfoModal(rPriceInfos: RPriceInfoModel[], anchor: any) {

        if (!this.isActivePriceApprovalMode()) {
            return;
        }

        this.modalVisibilityService.announceCloseEditDialogModalsRequest('supply openRPricesInfoModal');

        if (!rPriceInfos || rPriceInfos.length === 0) {
            // console.log('rPrice infos are not defined');
            return;
        }

        const deltaX = -190;
        const deltaY = 0;


        const msgRows = rPriceInfos.map(rPriceInfo => {
            const formattedRPrice = new DecimalPipe('de-DE').transform(+rPriceInfo.rPrice, '1.2-2');
            return formattedRPrice + ' € (' + rPriceInfo.rPriceIdentifier + ')';
        });


        // helps avoid to display dialog out of the screen
        const expectedDialogHeight = (rPriceInfos.length * 28) + 12;
        const marginBottom = 10;

        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;

        let top = Math.floor(+anchor.getBoundingClientRect().top) + deltaY;

        if (windowHeight - expectedDialogHeight < top) {
            top = windowHeight - (expectedDialogHeight + marginBottom);
        }

        const right = Math.floor(windowWidth - anchor.getBoundingClientRect().right) - deltaX;

        this.rPriceInfoModalDialogRef = this.modalDynamicV3Service
            .open(RPriceInfoModalComponent, {
                model: {
                    msgRows: msgRows,
                    top: top + 'px',
                    right: right + 'px',
                    showCloseBtn: false,
                    minHeight: 40,
                }
            });


        this.modalVisibilitySub = this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$.subscribe(_ => {

            if (this.rPriceInfoModalDialogRef) {
                this.rPriceInfoModalDialogRef.close();
                this.modalVisibilitySub.unsubscribe();
                this.rPriceInfoModalDialogRef = undefined;
                this.modalVisibilitySub = undefined;
            }
        });

    }


    public closeRPricesInfoModal() {
        if (this.rPriceInfoModalDialogRef) {
            this.rPriceInfoModalDialogRef.close();
            this.rPriceInfoModalDialogRef = undefined;
        }
    }

    public ngOnDestroy(): void {
        if (this.modalVisibilitySub) {
            this.modalVisibilitySub.unsubscribe();
        }
    }


    public getSupplyContainersList(deviceContainer: MyDeviceRequestContainerModel): MyNotDeviceRequestContainerModel[] {
        switch (SupplyAcquisitionTypeEnum[this.model.project.supplyAcquisitionType]) {
            case SupplyAcquisitionTypeEnum.PURCHASE:
                return deviceContainer.supplies;
            case SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT:
                return deviceContainer.mpsSupplies;
        }
        return [];
    }

    public isColorPrinter(printer: ProductModel ): boolean {
        return this.editModalService.containerUtilsService.isColorPrinter(printer);
    }
}
